import {
  compose, getContext, withHandlers,
} from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { identity, pathOr } from 'ramda';
import CompleteSprintModal from './completeSprintModal';
import { projectActions, projectSelectors } from '../../../../../state/project';
import { withSprintsCRUDHandlers } from '../../../../../utils/enchancers';
import { getModal } from '../../../../../state/ui/selectors';
import { SPRINT_STATUS } from '../../../../../constants/sprints';

const mapStateToProps = (state, { selectedSprintId }) => ({
  isOpen: getModal(state)('completeSprintModal'),
  isPending: projectSelectors.getDeleteSprintRequestPending(state),
  sprint: projectSelectors.getProjectSprint(state)(selectedSprintId),
});

const mapDispatchToProps = {
  updateSprint: projectActions.updateSprintRequest,
};

const onCompleteHandler = ({
  selectedSprintId, projectId, sprintCRUDMeta, updateSprint, onClose, sprint,
}) => () => updateSprint({
  meta: sprintCRUDMeta,
  sprintId: selectedSprintId,
  projectId,
  ...sprint,
  status: SPRINT_STATUS.COMPLETE,
}, {
  ...sprintCRUDMeta,
  callbacks: {
    success: compose(onClose, pathOr(identity, ['callbacks', 'success'], sprintCRUDMeta)),
  },
});

const onCloseHandler = ({ onCloseModal }) => () => onCloseModal('completeSprintModal');

const enhance = compose(
  getContext({
    selectedSprintId: PropTypes.number.isRequired,
    sprintCRUDMeta: PropTypes.instanceOf(Object).isRequired,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withSprintsCRUDHandlers,
  withHandlers({
    onClose: onCloseHandler,
  }),
  withHandlers({
    onComplete: onCompleteHandler,
  }),
);

export default enhance(CompleteSprintModal);
